import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";
import { useNavigate } from "react-router-dom";

const NewLimit = (props) => {
  const { currentCustomerObj, userData, refreshList } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [currencyData, setCurrencyData] = useState([]);
  const [liabilityData, setLiabilityData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const liabilityCategory = Form.useWatch("liabilityCategoryId", useForm);
  const navigate = useNavigate();

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    BOM.HasPermission("READ_CLIENT_LIMIT") && getTemplate();
  }, []);

  function getTemplate() {
    const params = {};
    const url = `${apiConfig.ClientLimit}/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempLiability = [];
        let tempCurrency = [];

        objDetail?.liabilityCategories.forEach((element) => {
          tempLiability.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(tempCurrency);
        setLiabilityData(tempLiability);
        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          revolvingLine: objDetail.revolvingLine,
          retrieveCollaterals: objDetail.retrieveCollaterals,
          isActive: objDetail.isActive,
        });
        setIsLoading(false);
      }
    });
  }

  const onSubmitLimit = (formValues) => {
    formValues.limitEndDate = BOM.DateTime(
      formValues.limitEndDate,
      "only-date"
    );
    formValues.clientId = currentCustomerObj.id;
    formValues.liabilityId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      apiConfig.ClientLimit,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.newLimitMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          onClick={showModal}
        >
          <PlusCircleOutlined />
          &nbsp;{labelConfig.add}
        </Button>
      )}
      <Modal
        title="New Limit"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmitLimit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">{labelConfig.generalInfo}</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.currency}
                name="currencyCode"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.currency),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.currency} *`,
                    "select"
                  )}
                  options={currencyData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.liabilityCategory}
                name="liabilityCategoryId"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.liabilityCategory),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.liabilityCategory} *`,
                    "select"
                  )}
                  options={liabilityData}
                  showSearch
                />
              </Form.Item>
            </Col>
            {liabilityCategory && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item name="accountLimit" label={labelConfig.limitAmount}>
                  <InputNumber
                    formatter={(value) =>
                      value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) =>
                      value ? value.replace(/(,*)/g, "") : ""
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.limitAmount
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.status}
                name="isActive"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.status),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.status} *`,
                    "select"
                  )}
                  options={staticConfig.statusData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.revolvingLine}
                name="revolvingLine"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.revolvingLine),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.revolvingLine} *`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.retrieveCollateral}
                name="retrieveCollaterals"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.retrieveCollateral),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.retrieveCollateral} *`,
                    "select"
                  )}
                  options={staticConfig.yesOrNoData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.limitEndDate}
                name="limitEndDate"
                rules={[
                  () => ({
                    validator(_, value) {
                      const today = dayjs();
                      if (!value) {
                        return Promise.reject(
                          new Error(`Please select end date`)
                        );
                      }
                      if (value?.isBefore(today, "day")) {
                        return Promise.reject(
                          new Error(
                            `End date cannot be lesser than ${today.format(
                              "YYYY-MM-DD"
                            )} (Today)`
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  // disabledDate={disabledAfterCurrentDate}
                  // size="small"
                  style={{ width: "100%", height: 35 }}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row>
            <Divider orientation="left">
              {labelConfig.amountInformation}
            </Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.globalLimit}
                name="globalLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.globalLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.globalLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountLimit}
                name="accountLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.accountLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.cardLimit}
                name="cardLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.cardLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.cardLimit)}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row> */}
          {/* <Row>
            <Divider orientation="left">
              {labelConfig.utilizationInformation}
            </Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.utilizedLimit}
                name="utilizedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.utilizedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.utilizedLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.unUsedLimit}
                name="unUsedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.unUsedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.unUsedLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.unAuthorisedLimit}
                name="unAuthorisedLimit"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.unAuthorisedLimit),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.unAuthorisedLimit
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.digitsAfterDecimal}
                name="digitsAfterDecimal"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.digitsAfterDecimal),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.digitsAfterDecimal
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.inMultiplesOf}
                name="inMultiplesOf"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.inMultiplesOf),
                  },
                ]}
              >
                <InputNumber
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.inMultiplesOf
                  )}
                  style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row> */}
        </Spin>
      </Modal>
    </>
  );
};

export default NewLimit;
